export default __webpack_public_path__ + "static/media/menu7.2c41c9a6.svg";